import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledSelectedInfo = styled.div`
  display: flex;
  align-self: center;
  margin-right: 2rem;
`;
export const StyledSelectedInfoEntity = styled.div`
  display: flex;
  font-size: 1.5rem;
  color: ${getColor('shuttleGray')};
  &.isActive {
    text-decoration: underline;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  &:not(:last-child) {
    &::after {
      content: '|';
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
`;

export const StyledHeaderTitle = styled.div`
  margin-bottom: 1rem;
  display: flex;
  & > h3 {
    text-transform: uppercase;
  }
  & ${StyledSelectedInfo} {
    margin-left: auto;
  }
`;
